import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { BaselineLine } from "@/lib/project-report-calc";

/**
 * Baseline-snapshotene for prosjektrapportens debrief-del (VIB-1068).
 * `budget_line_baseline` er immutabel (VIB-1057 #2) og leses kun her —
 * resten av rapportens data kommer ferdig hentet fra ProjectDetailContext.
 * Bundet på project_id (indeksert) → paginate-gate ikke relevant.
 */
export function useProjectReport(projectId: string | undefined) {
  return useQuery({
    queryKey: ["project-report", projectId],
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<BaselineLine[]> => {
      const { data, error } = await supabase
        .from("budget_line_baseline")
        .select(
          "budget_line_id, phase, description, cost_type, quantity_hours, amount, estimated_cost, captured_at",
        )
        .eq("project_id", projectId!);
      if (error) throw error;
      return (data ?? []) as BaselineLine[];
    },
  });
}
